import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-badge-renderer',
  templateUrl: './custom-badge-renderer.component.html',
  styleUrl: './custom-badge-renderer.component.scss'
})
export class CustomBadgeRendererComponent implements ICellRendererAngularComp {

  params: any;
  value: string = '';
  badgeClass: string = '';

  agInit(params: any): void {

    this.params = params;
    this.value = params.value;

    switch (this.value) {
      case 'Booked':
        this.badgeClass = 'ag-grid-pill-info';
        break;
      case 'Delivered':
      case 'In Review':
      case 'Pending':
        this.badgeClass = 'ag-grid-pill-warning';
        break;
      case 'Provider Delivered':
      case 'In Transit':
      case 'Live':
      case 'Active':
      case 'Published':
        this.badgeClass = 'ag-grid-pill-success';
        break;
      case 'Deactivated':
      case 'Inactive':
      case 'Unpublished':
        this.badgeClass = 'ag-grid-pill-danger';
        break;
      case 'Draft':
        this.badgeClass = 'ag-grid-pill-secondary';
        break;
      default:
        this.badgeClass = 'ag-grid-pill-secondary';
        break;
    }

  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.value = params.value;
    return true;
  }
}
